import * as React from 'react';

import TranslationActions from 'actions/TranslationActions';

import errorLogger from 'utils/errorLogger';

import TooltipHovercardIconButton from 'translations/components/TooltipHovercardIconButton';
import { TranslationsHoverCard } from 'translations/components/TranslationsHoverCard';
import { GetLanguageSet_translations_getLanguageSet_data_languageCounts as LanguageCounts } from 'translations/queries/__generated__/GetLanguageSet';
import LayerTrigger from 'components/LayerTrigger';
import { EditedMessageTranslationsType } from 'translations/types';

export type Props = {
  onTextChange?: (text: string) => void;
  onLangChange?: (lang: string) => void;
  textToTranslate: string;
  className?: string;
  eventKey?: string;
  eventProperties?: { [key: string]: any };
  dataTestSelector?: string;
  languageCounts: LanguageCounts[];
  toggleTranslate: (shouldTranslate: boolean) => void;
  shouldTranslate: boolean;
  isDisabled: boolean;
  displayTranslatedMessagePreview: (languageCode: string) => void;
  backToOriginalCallback: () => void;
  translationsPreviewActive: boolean;
  editedTranslations: EditedMessageTranslationsType;
  detectedMessageLanguage: string;
};

class TranslateButton extends React.Component<Props> {
  handleTranslateTo = (
    lang: string,
    text: string,
    onTextChange?: (text: string) => void,
    onLangChange?: (lang: string) => void
  ) => {
    TranslationActions.translate(text, lang)
      .then(response => {
        if (onLangChange) {
          onLangChange(lang);
        }
        if (onTextChange) {
          onTextChange(response.translation);
        }
      })
      .catch(errorLogger('TranslateButton translate failed'));
  };

  render() {
    const {
      shouldTranslate,
      languageCounts,
      toggleTranslate,
      isDisabled,
      displayTranslatedMessagePreview,
      backToOriginalCallback,
      translationsPreviewActive,
      editedTranslations,
      detectedMessageLanguage,
      ...props
    } = this.props;

    return (
      <TooltipHovercardIconButton
        data-test="translate-button"
        icon="translation"
        layerPlacement="top"
        layerAlignment="left"
        disabled={isDisabled}
        switchedOn={shouldTranslate}
        layer={(layerTrigger: LayerTrigger) => (
          <TranslationsHoverCard
            data-test="translations-hover-card"
            languageCounts={languageCounts}
            detectedMessageLanguage={detectedMessageLanguage}
            toggleTranslate={toggleTranslate}
            shouldTranslate={shouldTranslate}
            onMenuItemSelect={displayTranslatedMessagePreview}
            translationsPreviewActive={translationsPreviewActive}
            backToOriginalCallback={() => {
              layerTrigger.hideLayer();
              backToOriginalCallback();
            }}
            toggleHoverCardVisibility={() => {
              layerTrigger.toggleLayer();
            }}
            editedTranslations={editedTranslations}
          />
        )}
        tooltipText={'Translate'}
        controlled
        {...props}
      />
    );
  }
}

export default TranslateButton;
